import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { DateService } from '@thewhite/react-global-module/lib/services';
import * as t from 'io-ts';
import { OrganizationCategory, OrganizationCategoryType } from '../../Dictionaries/models/organizationCategory';
import BASE_STATUS from '../../Global/enums/baseStatus';

export const OrganizationType = t.interface({
    id: t.string,
    inn: t.union([t.string, t.null, t.undefined]),
    name: t.union([t.string, t.null, t.undefined]),
    status: t.union([t.string, t.null, t.undefined]),
    imageId: t.union([t.string, t.null, t.undefined]),
    shortName: t.union([t.string, t.null, t.undefined]),
    createDate: t.union([t.string, t.null, t.undefined]),
    description: t.union([t.string, t.null, t.undefined]),
    category: t.union([OrganizationCategoryType, t.null, t.undefined]),
});

export interface OrganizationDTO extends t.TypeOf<typeof OrganizationType> {}

export class Organization {
    id: string;
    inn: string | null;
    name: string | null;
    imageId: string | null;
    createDate: Date | null;
    shortName: string | null;
    description: string | null;
    category: OrganizationCategory | null;
    status: SimpleObjectInterface | null;

    constructor(params: OrganizationDTO) {
        this.id = params.id;
        this.inn = params.inn ?? null;
        this.name = params.name ?? null;
        this.imageId = params.imageId ?? null;
        this.status = !!params.status
            ? BASE_STATUS[params.status]
            : null;
        this.shortName = params.shortName ?? null;
        this.description = params.description ?? null;
        this.category = params.category
            ? new OrganizationCategory(params.category)
            : null;
        this.createDate = !!params.createDate
            ? DateService.getValidDate(params.createDate)
            : null;
    }
}
